// extracted by mini-css-extract-plugin
export default {"price":"modal_discount_main_price__AqLKb"};